import { resizeImageData } from './resizeImageData'

/**
 * Downscale ImageData if needed
 * Works in both main thread (document) and worker (OffscreenCanvas)
 * @param {ImageData} imageData
 * @param {number} maxSize
 * @returns {{imageData: ImageData, scale: number}}
 */
export function downscaleImageData(imageData, maxSize) {
    const maxDimension = Math.max(imageData.width, imageData.height)

    if (maxDimension <= maxSize) {
        return { imageData, scale: 1 }
    }

    const scale = maxSize / maxDimension
    const newWidth = Math.floor(imageData.width * scale)
    const newHeight = Math.floor(imageData.height * scale)

    const processedImageData = resizeImageData(imageData, newWidth, newHeight)

    return { imageData: processedImageData, scale }
}

